<template>
    <v-tabs>
        <v-tab
            :to="{
                name: 'customer.show',
                params: { id: customer },
            }"
        >
            {{ $t('customer.tabs.title') }}
        </v-tab>
        <v-tab
            :to="{
                name: 'plan-proposal.index',
                params: { customer_id: customer },
            }"
        >
            {{ $tc('resources.plan-proposal.name', 1) }}
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    props: {
        customer: {
            required: true,
        },
    },
}
</script>

<style></style>
